export default {
  employees: [],
  employeesGrid: {
    data: [],
    total: 0
  },
  employee: {}
}
